import { render, staticRenderFns } from "./Lgx202100746110369792.vue?vue&type=template&id=14807685&scoped=true&"
import script from "./Lgx202100746110369792.vue?vue&type=script&lang=js&"
export * from "./Lgx202100746110369792.vue?vue&type=script&lang=js&"
import style0 from "./Lgx202100746110369792.vue?vue&type=style&index=0&id=14807685&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14807685",
  null
  
)

export default component.exports